var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Sport-Traithlon--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Sport Traithlon Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.43 2.25a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0 -4.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.18 9.75a3.16 3.16 0 0 0 2 -0.7 3.13 3.13 0 0 0 2 0.7 3.29 3.29 0 0 0 2.62 -1.33 0.74 0.74 0 0 0 -0.21 -1 0.75 0.75 0 0 0 -1 0.2 1.72 1.72 0 0 1 -1.37 0.67 1.75 1.75 0 0 1 -1.38 -0.67 0.74 0.74 0 0 0 -0.13 -0.12 0.2 0.2 0 0 0 -0.08 -0.08 0.9 0.9 0 0 0 -0.27 -0.11H19a0.72 0.72 0 0 0 -0.27 0.12s-0.06 0.06 -0.1 0.09 -0.08 0.07 -0.11 0.11a1.76 1.76 0 0 1 -1.37 0.66 1.74 1.74 0 0 1 -1.38 -0.67 0.76 0.76 0 0 0 -0.62 -0.33 0.78 0.78 0 0 0 -0.63 0.33 1.72 1.72 0 0 1 -1.37 0.67 0.75 0.75 0 0 0 0 1.5 3.24 3.24 0 0 0 2 -0.69 3.19 3.19 0 0 0 2.03 0.65Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.66 4.65a4.77 4.77 0 0 1 -0.26 0.86 3.56 3.56 0 0 0 0.78 -0.45 3.19 3.19 0 0 0 2 0.69 3.16 3.16 0 0 0 2 -0.7 3.13 3.13 0 0 0 2 0.7 3.29 3.29 0 0 0 2.62 -1.33 0.74 0.74 0 0 0 -0.21 -1 0.75 0.75 0 0 0 -1 0.2 1.72 1.72 0 0 1 -1.37 0.67 1.75 1.75 0 0 1 -1.38 -0.67 0.74 0.74 0 0 0 -0.13 -0.12 0.2 0.2 0 0 0 -0.08 -0.08 0.9 0.9 0 0 0 -0.27 -0.11H19a0.72 0.72 0 0 0 -0.27 0.12s-0.06 0.06 -0.1 0.09 -0.08 0.07 -0.11 0.11a1.76 1.76 0 0 1 -1.37 0.66 1.74 1.74 0 0 1 -1.38 -0.67 0.76 0.76 0 0 0 -0.62 -0.33 0.78 0.78 0 0 0 -0.63 0.33 1.2 1.2 0 0 1 -0.26 0.27 0.75 0.75 0 0 1 0.4 0.76Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.79a0.75 0.75 0 1 0 -0.75 1.29 2.39 2.39 0 0 1 1.19 2.05 2.37 2.37 0 0 1 -4.32 1.34 0.75 0.75 0 0 0 -1.23 0.85A3.86 3.86 0 1 0 22 16.79Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.74 22.06a2.31 2.31 0 0 1 -1.37 0.44A2.37 2.37 0 0 1 8 20.13a2.57 2.57 0 0 1 0.09 -0.67 0.75 0.75 0 1 0 -1.43 -0.46 4 4 0 0 0 -0.15 1.09 3.86 3.86 0 0 0 6.1 3.15 0.74 0.74 0 0 0 0.18 -1 0.75 0.75 0 0 0 -1.05 -0.18Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.19 20.15a0.76 0.76 0 0 0 0.74 0.6h0.14a0.76 0.76 0 0 0 0.59 -0.89l-1.32 -6.6h1.84a0.75 0.75 0 0 0 0 -1.5h-2.75a0.75 0.75 0 0 0 -0.58 0.27 0.76 0.76 0 0 0 -0.16 0.63l0.22 1.09 -4.9 0.38a0.73 0.73 0 0 0 -0.6 0.4L9.52 19.9a0.73 0.73 0 0 0 0 0.73 0.76 0.76 0 0 0 0.65 0.37h5a0.75 0.75 0 0 0 0.62 -0.34l2.68 -4.06Zm-4.42 -0.65h-3.34l2.1 -3.91 4 -0.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.45 11.75a0.75 0.75 0 0 0 0 1.5h1.48a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.08 15.52 -0.08 0.74a1.06 1.06 0 0 0 0.93 1.19h0.14a1.07 1.07 0 0 0 1.06 -0.94l0.09 -0.73a5.59 5.59 0 0 0 -3.44 -5.87l1.29 -2.57a5.41 5.41 0 0 0 3.36 0.11 5.48 5.48 0 0 0 2.82 -2.28A1.07 1.07 0 1 0 11.46 4a3 3 0 0 1 -4.08 1.19l-0.27 -0.11C4.57 4.06 2.89 3.39 0.32 6a1.07 1.07 0 0 0 0 1.52 1 1 0 0 0 0.75 0.32 1.07 1.07 0 0 0 0.76 -0.32C3.09 6.23 3.64 6.1 5 6.59L3.34 10l0 0.05a1.35 1.35 0 0 0 0 0.28 0.38 0.38 0 0 0 0 0.1v1.94a3.31 3.31 0 0 1 -1.48 2.77L0.48 16a1.07 1.07 0 0 0 -0.3 1.49 1.09 1.09 0 0 0 0.9 0.48 1.07 1.07 0 0 0 0.59 -0.18L2.93 17a5.46 5.46 0 0 0 2.44 -4.56v-0.34a3.45 3.45 0 0 1 1.71 3.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSports);
export default ForwardRef;